/**
 * Caps for practice / personalized article unit selection.
 * Keep band table in sync with backend {@code PracticeLimits}.
 * Absolute ceiling matches {@code app.limits.practice-max-units} (default 12).
 *
 * Later: hydrate from settings/bootstrap for Free/Pro tiers.
 */

export const PRACTICE_UNITS_ABSOLUTE_MAX = 12
export const maxArticleUnits = 10

/** @deprecated Prefer {@link practiceUnitLimits} — absolute ceiling only. */
export const maxPracticeUnits = PRACTICE_UNITS_ABSOLUTE_MAX

export type PracticeUnitLimitBand = {
  max: number
  /** “Pick random” count — nearer the lower end of the band. */
  defaultPick: number
}

/**
 * CEFR-scaled practice caps so short lesson scenarios stay natural.
 * A1–A2 → max 8 / pick 6 · B1 → max 10 / pick 8 · B2+ → max 12 / pick 10
 */
export function practiceUnitLimits(cefrLevel?: string | null): PracticeUnitLimitBand {
  const band = normalizeBand(cefrLevel)
  const byLevel =
    band === 'A'
      ? { max: 8, defaultPick: 6 }
      : band === 'B1'
        ? { max: 10, defaultPick: 8 }
        : { max: 12, defaultPick: 10 }

  const max = Math.min(byLevel.max, PRACTICE_UNITS_ABSOLUTE_MAX)
  return {
    max,
    defaultPick: Math.min(byLevel.defaultPick, max),
  }
}

function normalizeBand(cefrLevel?: string | null): 'A' | 'B1' | 'B2Plus' {
  if (!cefrLevel?.trim()) return 'B1'
  const level = cefrLevel.trim().toUpperCase()
  if (level.startsWith('A')) return 'A'
  if (level === 'B1') return 'B1'
  return 'B2Plus'
}
